import React from "react";
import aurelia from "../assets/case-studies/aurelia-cs.png";

export default function AureliaHeightsCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={aurelia} alt="Aurelia" width="80%" />
    </div>
  );
}
